import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { buildServiceSchema } from '../../builders/service'
import { PageMeta } from '../../types'

const description =
  'シンプルで直感的に使いやすいプッシュ通知サービスの決定版。顧客属性DBを活用し、細やかなセグメント配信で効果的なコミュニケーションを実現します。'

export const zebraPageMeta: PageMeta = {
  title: 'ZEBRA | サービス | i3DESIGN アイスリーデザイン',
  description,
  keyword: 'ZEBRA プッシュ通知 配信 モバイルアプリ iPhone Android 安い',
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/zebra/`,
}

export const zebraSchema = buildServiceSchema({
  slug: 'zebra',
  name: 'プッシュ通知サービス ZEBRA',
  description: zebraPageMeta.description,
  serviceType: 'プッシュ通知サービス ZEBRA',
  category: '製品・サービス',
  offerCatalogName: 'プッシュ通知サービス ZEBRA',
  breadcrumbName: 'プッシュ通知サービス ZEBRA',
  offers: [
    {
      name: 'プッシュ通知サービス',
      description:
        '顧客属性データベースを活用した細やかなセグメント配信や多彩な通知機能により、ターゲットに合わせた最適なアプローチが可能です。さらに、詳細な分析機能で効果を測定することで、配信戦略を継続的に最適化し、最大の結果を引き出せます。',
    },
  ],
})
